<template>
  <Menu as="div" class="relative inline-block text-left">
    <MenuButton
      class="flex items-center w-auto sm:w-[200px] justify-center gap-x-1.5 rounded py-1 text-sm font-semibold text-white shadow-sm ring-2 h-full ring-inset ring-gray-200 bg-[#D9D9D9]"
    >
      <div
        class="max-w-[100px] p-2 sm:max-w-[150px] text-black overflow-hidden truncate text-xl font-semibold"
      >
        {{ user.ten_hien_thi }}
      </div>
    </MenuButton>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="absolute right-0 z-10 mt-2 w-72 origin-top-right border border-white rounded-md bg-[#1C2833] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div class="px-4 py-2 flex flex-col gap-2 sm:gap-4">
          <slot></slot>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'
import { UserCircleIcon } from '@heroicons/vue/24/solid'

const props = defineProps(['user'])
</script>
